module.exports = __webpack_public_path__ + "img/multidevice.0f1be31e.png";